export default __webpack_public_path__ + "assets/upload_logo_product.78c41a.png";